<template>
    <div class="code" :style="`height: ${height}`">

        <div class="head">
            <img class="sprite" src="/images/game/sprite-4.png"/>
            <img class="logo" src="/images/game/m-logo.png"/>
        </div>
        <div class="body">
            <div v-if="exchange">
                <div class="h5">
                    <img src="/images/game/兑换成功.png"/>奖品已核销！
                </div>
                <div class="h6">{{util.toDateTimeString(exchangeTime)}}</div>
            </div>
            <div v-else>
                <div class="h1">核销码</div>
                <div class="qr-code">
                    <canvas id="canvas"></canvas>
                </div>
                <div class="h2">请向咏悦汇店员展示此核销码领取奖品</div>
            </div>
            <div class="h3">领取奖品：</div>
            <div class="commodity">
                <div class="left">
                    <div class="name">{{name}}</div>
                    <div class="content">
                        <div class="price">¥{{price}}</div>
                        <div class="count">X {{count}}</div>
                    </div>
                </div>
                <div class="right">
                    <img :src="util.getImageUrl(image, '-120')"/>
                </div>
            </div>


            <!--            <div class="circle-left"></div>-->
            <!--            <div class="circle-right"></div>-->
        </div>
    </div>
</template>

<script>
    import QRCode from "qrcode"

    export default {
        name: "Code",
        data() {
            return {
                exchange: false,
                exchangeTime: null,
                url: "",
                name: "",
                price: "",
                count: "",
                image: "",

                height: 667,
            }
        },
        beforeCreate() {
            /**
             * YDUI 可伸缩布局方案
             * rem计算方式：设计图尺寸px / 100 = 实际rem  【例: 100px = 1rem，32px = .32rem】
             */
            !function (window) {

                /* 设计图文档宽度 */
                var docWidth = 750;

                var doc = window.document,
                    docEl = doc.documentElement,
                    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';

                var recalc = (function refreshRem () {
                    var clientWidth = docEl.getBoundingClientRect().width;

                    /* 8.55：小于320px不再缩小，11.2：大于420px不再放大 */
                    docEl.style.fontSize = Math.max(Math.min(20 * (clientWidth / docWidth), 11.2), 8.55) * 5 + 'px';

                    return refreshRem;
                })();

                /* 添加倍屏标识，安卓为1 */
                docEl.setAttribute('data-dpr', window.navigator.appVersion.match(/iphone/gi) ? window.devicePixelRatio : 1);

                if (/iP(hone|od|ad)/.test(window.navigator.userAgent)) {
                    /* 添加IOS标识 */
                    doc.documentElement.classList.add('ios');
                    /* IOS8以上给html添加hairline样式，以便特殊处理 */
                    if (parseInt(window.navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/)[1], 10) >= 8)
                        doc.documentElement.classList.add('hairline');
                }

                if (!doc.addEventListener) return;
                window.addEventListener(resizeEvt, recalc, false);
                doc.addEventListener('DOMContentLoaded', recalc, false);

            }(window);
        },
        async created() {

            const RATIO = 1334 / 750;

            const ratio = window.innerHeight / window.innerWidth;

            if (ratio > RATIO) {
                this.height = 7.5 * ratio + "rem";

                console.log(this.height)
            }

            // if (ratio <= 0.56221889) {
            //     console.log(window.innerHeight)
            // }

            console.log(this.$route.query)

            const response = await this.ajax.doPost({
                packageName: "game",
                className: "common",
                methodName: "getPrizeByCode",
                params: {
                    code: this.$route.query.code
                }
            });

            this.exchange = response.exchange;
            this.exchangeTime = new Date(response.exchangeTime);

            this.url = response.url;
            this.name = response.name;
            this.price = response.price;
            this.count = response.count;
            this.image = response.image;

            if (!this.exchange) {
                const canvas = document.getElementById('canvas');

                QRCode.toCanvas(canvas, this.url, {
                    errorCorrectionLevel: 'L',
                    margin: 0,
                    width: 145,
                }, function (error) {
                    if (error) console.error(error)
                    console.log('success!');
                })
            }


        },
    };
</script>

<style lang="scss" scoped>
    .code {
        width: 7.5rem;
        height: 13.34rem;
        /*height: 100%;*/
        background: linear-gradient(
                        360deg,
                        rgba(245, 224, 181, 1) 0%,
                        rgba(184, 142, 63, 1) 100%
        );
        user-select: none;


        .head {
            width: 100%;
            height: 4.54rem;
            position: relative;

            .sprite {
                position: absolute;
                width: 5.42rem;
                left: -1rem;
                top: 1.3rem;
            }

            .logo {
                position: absolute;
                width: 3.58rem;
                top: 1.6rem;
                right: 0.4rem;
            }
        }

        .body {
            margin: 0 auto;
            width: 6.7rem;
            height: 8.4rem;
            background: rgba(255, 255, 255, 1);

            position: relative;
            overflow: hidden;

            .circle-left {
                position: absolute;
                left: -0.2rem;
                top: 50%;
                transform: translateY(-50%);

                height: 0.4rem;
                width: 0.4rem;
                border-radius: 50%;

                /*opacity: .1;*/
                background: rgba(1, 1, 1, 1);
                background: #E3C68E;
            }

            .circle-right {
                position: absolute;
                right: -0.2rem;
                top: 50%;
                transform: translateY(-50%);

                height: 0.4rem;
                width: 0.4rem;
                border-radius: 50%;
                /*opacity: .1;*/
                background: rgba(1, 1, 1, 1);
                background: #E3C68E;

                background: linear-gradient(
                                360deg,
                                #E3C791 0%,
                                #E2C690 100%
                );


            }

            .h5 {
                padding: 1.6rem 0 0.4rem 0;
                text-align: center;
                font-size: 0.44rem;
                font-weight: 600;
                color: rgba(0, 0, 0, 1);
                line-height: 0.68rem;

                img {
                    vertical-align: top;
                    margin-right: 12px;
                    width: 0.68rem;
                    height: 0.68rem;
                }
            }

            .h6 {
                padding: 0 0 1.6rem 0;
                text-align: center;
                font-size: 0.28rem;
                font-weight: 400;
                color: rgba(109, 114, 120, 1);
            }

            .h1 {
                padding: 0.2rem 0;
                text-align: center;

                font-size: 0.36rem;
                font-weight: 600;
                color: rgba(0, 0, 0, 1);

            }

            .qr-code {
                text-align: center;
            }

            .h2 {
                padding: 0.2rem 0;
                text-align: center;
                font-size: 0.28rem;
                font-weight: 400;
                color: rgba(109, 114, 120, 1);
            }

            .h3 {
                padding-top: 0.2rem;
                text-align: center;
                font-size: 0.32rem;
                font-weight: 600;
                color: rgba(51, 51, 51, 1);

            }

            .commodity {
                margin-top: 0.4rem;

                .left {
                    vertical-align: top;
                    display: inline-block;
                    width: 3.1rem;
                    margin-left: 0.4rem;

                    .name {
                        width: 3.1rem;
                        height:0.8rem;
                        font-size: 0.28rem;
                        font-weight: 500;
                        color: rgba(0, 0, 0, 1);
                        line-height: 0.4rem;
                    }

                    .content {
                        width: 3.1rem;
                        margin-top: 0.4rem;

                        .price {
                            height: 0.44rem;
                            font-size: 0.36rem;
                            font-family: DINMedium;
                            color: rgba(194, 139, 43, 1);
                            line-height: 0.44rem;
                            float: left;
                        }

                        .count {
                            float: right;
                            height: 0.34rem;
                            font-size: 0.28rem;
                            font-family: DINMedium;
                            color: rgba(0, 0, 0, 1);
                            line-height: 0.34rem;
                        }
                    }


                }

                .right {
                    vertical-align: top;
                    display: inline-block;
                    width: 2.4rem;
                    margin-left: 0.4rem;


                    height: 2.4rem;
                    background: rgba(250, 250, 250, 1);
                    overflow: hidden;
                    text-align: center;

                    img {
                        height: 2.4rem;
                    }
                }
            }
        }
    }
</style>